import {Component, Input, OnInit} from '@angular/core';
import {SearchResult, SearchResultItem} from '../interface.search';

@Component({
  selector: 'app-modulesearchresult',
  templateUrl: './modulesearchresult.component.html',
  styleUrls: ['./modulesearchresult.component.css']
})
export class ModulesearchresultComponent implements OnInit {
  @Input() result: SearchResult;
  @Input() initialLimit = 10;
  public limitSize: number;
  public lowerLimit: number;
  constructor() { }

  ngOnInit() {
    this.limitSize = this.initialLimit;
    this.lowerLimit = this.initialLimit;
  }

  showMore() {
    this.limitSize = 0;
  }
  showLess() {
    this.limitSize = this.initialLimit;
  }
}



// WEBPACK FOOTER //
// ./src/app/search/modulesearchresult/modulesearchresult.component.ts